/* RESPONSIBLE TEAM: team-pricing-and-packaging */
import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { inject as service } from '@ember/service';
import type ExpiredSubscriptionService from 'embercom/services/expired-subscription-service';
export default class ExpiredSubscription extends Route {
  @service declare expiredSubscriptionService: ExpiredSubscriptionService;
  @service declare appService: any;
  @service declare customerService: any;
  @service declare router: RouterService;

  async beforeModel() {
    await this.appService.app.reload();
    await this.customerService.refreshCustomer();
    if (!this.appService.app.canDisplayExpiredSubscriptionPage) {
      this.router.transitionTo('apps.app');
    }
  }

  async model() {
    return {
      expirationReason: this.expiredSubscriptionService.expirationReason,
      adminHasBillingPermissions: this.expiredSubscriptionService.adminHasBillingPermissions,
      companySize: this.expiredSubscriptionService.companySize,
    };
  }
}
